export const userActionType = {
  SET_CURRENT_USER: 'SET_CURRENT_USER',
}
